<div class="row mb-3">
  <div class="col-lg-12">
    <dl class="dl-horizontal">
      <dt>Current Tier</dt>
      <dd>{{ currentTier }}</dd>
    </dl>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-trophy"></i> Leagues
      </div>
      <div class="card-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>Division ID</th>
              <th>Tier</th>
              <th>End Date</th>
              <th>Games</th>
              <th>Points</th>
              <th>Rank</th>
              <th>Reward</th>
            </tr>
          </thead>
          <tbody>
            @for (league of leagues; track league.divisionId; let i = $index) {
              <tr>
                <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                <td>{{ league.divisionId }}</td>
                <td>{{ league.divisionTier }}</td>
                <td>{{ league.divisionEndDateTimestamp !== 0 ? dateService.getDateFromatted(league.divisionEndDateTimestamp) : '-' }}</td>
                <td>{{ league.game }}</td>
                <td>{{ league.point }}</td>
                <td>{{ league.rank }}</td>
                <td>
                  @if (league.rank !== 0) {
                    @if (league.isRewardGranted) {
                      <span class="badge bg-success">Granted</span>
                    } @else {
                      <span class="badge bg-secondary">Pending</span>
                    }
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + leagues.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="leagues.length < resultsPerPage">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="leagues.length < resultsPerPage">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
